import MetaHead from "./MetaHead";

export default MetaHead;
